<template>
  <div class="view__wrap home__page">
    <div v-if="isAuth && user.email == null">
      <email-form :email="user.email"></email-form>
    </div>
    <div v-else-if="isAuth">
      <div class="form-layout-v2">
        <div class="form-sidebar-v2">
          <div class="form-panels-v2" id="accordionExample">
            <div class="panel-card-v2" v-if="order">
              <div class="panel-header-v2" id="headingFour" data-toggle="collapse" data-target="#collapseFour"
                aria-expanded="false" aria-controls="collapseFour">
                <div class="panel-title-v2">
                  <i class="fa fa-cog"></i>
                  <span>Параметри замовлення</span>
                </div>
                <i class="fa fa-chevron-down panel-arrow-v2"></i>
              </div>
              <div id="collapseFour" class="panel-content-v2 collapse" aria-labelledby="headingFour"
                data-parent="#accordionExample">

                <div class="checkbox-grid-compact">
                  <div class="checkbox-item-v2">
                    <input type="checkbox" class="checkbox-v2" id="customer_material" v-model="order.customer_material"
                      value="true">
                    <label for="customer_material" class="checkbox-label-compact">
                      <i class="fa fa-cube"></i>
                      Матеріал Клієнта
                    </label>
                  </div>

                  <div class="checkbox-item-v2">
                    <input type="checkbox" class="checkbox-v2" id="customer_edge" v-model="order.customer_edge"
                      value="true">
                    <label for="customer_edge" class="checkbox-label-compact">
                      <i class="fa fa-border-style"></i>
                      Кромка Клієнта
                    </label>
                  </div>

                  <div class="checkbox-item-v2">
                    <input type="checkbox" class="checkbox-v2" id="edge_size" v-model="order.edge_size" value="true">
                    <label for="edge_size" class="checkbox-label-compact">
                      <i class="fa fa-ruler-combined"></i>
                      Розмір з Кромкою
                    </label>
                  </div>

                  <div class="checkbox-item-v2">
                    <input type="checkbox" class="checkbox-v2" id="glue" v-model="order.glue" value="true">
                    <label for="glue" class="checkbox-label-compact">
                      <i class="fa fa-spray-can"></i>
                      Оклеювання PUR
                    </label>
                  </div>
                </div>
                <div class="order-fields-compact">
                  <!-- <div class="field-group-compact">
                    <label for="date_order" class="field-label-compact">Дата відвантаження</label>
                    <input disabled v-model="order.date_sale" id="date_order" type="date" class="field-input-compact" />
                  </div> -->
                  <div class="field-group-compact">
                    <!-- <label for="comment" class="field-label-compact">Коментар</label> -->
                    <textarea id="comment" class="field-input-compact" v-model="order.comment"
                      placeholder="Залишити коментар" rows="2"></textarea>
                  </div>
                </div>
              </div>
            </div>

            <div class="panel-card-v2">
              <div class="panel-header-v2" id="headingName" data-toggle="collapse" data-target="#collapseName"
                aria-expanded="false" aria-controls="collapseName">
                <div class="panel-title-v2">
                  <i class="fa fa-list"></i>
                  <span>Список виробів</span>
                </div>
                <i class="fa fa-chevron-down panel-arrow-v2"></i>
              </div>

              <div id="collapseName" class="panel-content-v2 collapse" aria-labelledby="headingName"
                data-parent="#accordionExample">
                <div>
                  <Details :detailsName="detailsName" />
                </div>
              </div>
            </div>
            <div class="panel-card-v2">
              <div class="panel-header-v2" id="headingOne" data-toggle="collapse" data-target="#collapseOne"
                aria-expanded="true" aria-controls="collapseOne">
                <div class="panel-title-v2">
                  <i class="fa fa-cube"></i>
                  <span>Матеріали</span>
                </div>
                <i class="fa fa-chevron-down panel-arrow-v2"></i>
              </div>

              <div id="collapseOne" class="panel-content-v2 collapse show" aria-labelledby="headingOne"
                data-parent="#accordionExample">
                <div class="component-wrapper-v2">
                  <materials />
                </div>
              </div>
            </div>
            <div class="panel-card-v2">
              <div class="panel-header-v2" id="headingTwo" data-toggle="collapse" data-target="#collapseTwo"
                aria-expanded="false" aria-controls="collapseTwo">
                <div class="panel-title-v2">
                  <i class="fa fa-border-style"></i>
                  <span>Кромки</span>
                </div>
                <i class="fa fa-chevron-down panel-arrow-v2"></i>
              </div>
              <div id="collapseTwo" class="panel-content-v2 collapse" aria-labelledby="headingTwo"
                data-parent="#accordionExample">
                <div class="component-wrapper-v2">
                  <edges />
                </div>
              </div>
            </div>
            <div class="panel-card-v2">
              <div class="panel-header-v2" id="headingThree" data-toggle="collapse" data-target="#collapseThree"
                aria-expanded="false" aria-controls="collapseThree">
                <div class="panel-title-v2">
                  <i class="fa fa-link"></i>
                  <span>Стяжки</span>
                </div>
                <i class="fa fa-chevron-down panel-arrow-v2"></i>
              </div>
              <div id="collapseThree" class="panel-content-v2 collapse" aria-labelledby="headingThree"
                data-parent="#accordionExample">
                <div class="component-wrapper-v2">
                  <screeds />
                </div>
              </div>
            </div>
            <order v-if="isAuth" />


          </div>
        </div>

        <div class="visual-section-v2">
          <div class="visual-card-v2">
            <div class="visual-header-v2">
              <h3><i class="fa fa-eye"></i> 2D Візуалізація</h3>
            </div>
            <div class="visual-content-v2">
              <visual v-if="details.length" />
            </div>
          </div>
        </div>
      </div>
      <form-table />

      <details v-if="order">
        <summary>Запит до 1С</summary>
        <pre style="border: 1px solid black">{{ request_data }}</pre>
      </details>
      <details v-if="resp">
        <summary>Відповідь 1С</summary>
        <pre style="border: 1px solid black">{{ resp }}</pre>
      </details>
    </div>


    <div v-else>
      <div class="col-12">
        Ви не авторизовані. Увійдіть через свій обліковий запис Клієнта на порталі.
        <router-link :to="{ name: 'login' }">Увійти</router-link>
      </div>
    </div>

    <search :what="toSearch" />
    <order-modal />
  </div>
</template>

<script>
import FormTable from '@/components/parts/DetailTableForm.vue'
import Edges from '@/components/parts/EdgeTable.vue'
import Materials from '@/components/parts/MaterialsTable.vue'
import Details from '@/components/parts/DetailsNameTable.vue'
import Screeds from '@/components/parts/Screeds.vue'
import Visual from '@/components/parts/Visual.vue'
import Search from "@/components/modals/search";
import Order from '@/components/Order.vue'
import OrderModal from "@/components/modals/OrderModal";
import EmailForm from "@/views/User/Settings";
import moment from "moment/moment";

export default {
  data() {
    return {
      user: this.$store.state.auth.user,
      isAuth: this.$store.state.auth.authenticated,
    }
  },
  computed: {
    materials() {
      return this.$store.state.data.materials;
    },
    request_data() {
      return this.$store.state.data.responseDebug && this.$store.state.data.responseDebug.request_data;
    },
    order: {
      get() {
        return this.$store.state.data.order;
      },
      set(value) {
        this.$store.commit('data/SET_ORDER', value);
      }
    },
    edges() {
      return this.$store.state.data.edges;
    },
    detailsName() {
      return this.$store.state.data.detailsNames;
    },
    details() {
      return this.$store.state.data.details;
    },
    materialDefault() {
      return this.$store.state.data.materialDefault;
    },
    edgeDefault() {
      return this.$store.state.data.edgeDefault;
    },
    resp() {
      let response1c = this.$store.state.data.response;
      if (response1c && typeof response1c.request_data != 'undefined') {
        delete response1c.request_data;
      }
      return response1c;
    },
    client() {
      return this.$store.state.auth.user;
    },
    toSearch() {
      return app.toSearch;
    }
  },
  methods: {
    search(v) {
      app.toSearch = v;
    },
  },
  watch: {
    client: {
      handler(value, old) {
        this.$store.state.auth.user = this.client;
      },
      deep: true
    },
    details: {
      handler(value, old) {
        app.details = this.details;
      },
      deep: true
    },
    order: {
      handler(newVal) {
        this.order = newVal;
      },
      deep: true
    }
  },
  mounted() {
    window.addEventListener("keydown", e => {
      if (e.keyCode === 192) {
        e.preventDefault();
        document.querySelector('input:focus').closest('tr').querySelector('.template').select();
      }

    });
    this.$root.$on('update', i => {
      this.$forceUpdate();
    });
  },
  components: {
    Search,
    FormTable,
    Edges,
    Materials,
    Screeds,
    Visual,
    Order,
    OrderModal,
    Details, EmailForm
  }
}
</script>

<style>
.card-header {
  position: relative;
}

.card-header b,
.card-header div {
  position: relative;
  left: 15px
}

.card-header::after {
  font-size: 11px;
  content: "▶";
  color: #333;
  top: 10px;
  left: 5px;
  position: absolute;
}

.card-header[aria-expanded="true"]::after {
  content: "▼";
}

details p {
  text-align: center;
}

.home__page {
  margin-top: 3rem;
}

.visual-container {
  min-width: 600px;
  min-height: 350px;
  padding-left: 1%;
  background: white;
  border-radius: 12px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.08);
  overflow: hidden;
}

.table {
  margin-bottom: 0 !important;
}

.card-header div {
  font-size: 12px;
  color: black;
}

.card-header button {
  z-index: 999999;
}

.details td,
.details th,
.tab-content td,
.tab-content th {
  padding: .2rem !important;
}

.tab-content .edges-container,
.tab-content .materials-container,
.tab-content .screeds-container {
  font-size: 13px;
}

.details table {
  font-size: 13px;
}

.help-link {
  position: fixed;
  right: 10px;
  bottom: 10px;
}

.nav-tabs a div {
  font-size: 11px;
}

.dism {
  font-size: 11px !important;
  display: block;
  position: absolute;
  top: 35px;
  right: -3px;
}

.nav-tabs .nav-link {
  color: #495057;
}

.nav-tabs .nav-link.active {
  color: #2c5aa0;
}

/* Modern Main Page Styles - как в Form.vue */
.view__wrap.home__page {
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;
  color: #2c3e50;
  background: #f8f9fa;
  min-height: 100vh;
  padding: 18px;
}

.details {
  display: grid;
  grid-template-columns: 0.8fr 1.2fr;
  gap: 18px;
  max-width: 1600px;
  margin: 0 auto;
}

.details__info {
  background: white;
  border-radius: 12px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.08);
  height: fit-content;
  position: sticky;
  top: 20px;
}

/* Form Layout для Main.vue */
.form-layout-v2 {
  display: grid;
  grid-template-columns: 0.8fr 1.2fr;
  gap: 18px;
  max-width: 1600px;
  margin: 0 auto;
}

.form-sidebar-v2 {
  background: white;
  border-radius: 12px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.08);
  height: fit-content;
  top: 20px;
}

.visual-section-v2 {
  background: white;
  border-radius: 12px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.08);
  overflow: hidden;
  height: fit-content;
}

/* Panels Styling для Main.vue */
.form-panels-v2 {
  display: flex;
  flex-direction: column;
}

.panel-card-v2 {
  border-bottom: 1px solid #e9ecef;
}

.panel-card-v2:last-child {
  border-bottom: none;
}

.accordion {
  display: flex;
  flex-direction: column;
}

/* Panel Card Styling */
.accordion_row {
  border-bottom: 1px solid #e9ecef;
}

.accordion_row:last-child {
  border-bottom: none;
}

.accordion_header,
.panel-header-v2 {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 12px 16px;
  background: #f8f9fa;
  cursor: pointer;
  transition: all 0.3s ease;
  border: none;
  outline: none;
}

.accordion_header:hover,
.panel-header-v2:hover {
  background: #e9ecef;
}

.accordion_header[aria-expanded="true"],
.panel-header-v2[aria-expanded="true"] {
  background: #2c5aa0;
  color: white;
}

.accordion_header[aria-expanded="true"] .panel-arrow-v2,
.panel-header-v2[aria-expanded="true"] .panel-arrow-v2 {
  transform: rotate(180deg);
  color: white;
}

.panel-title-v2 {
  display: flex;
  align-items: center;
  gap: 10px;
  font-size: 0.95rem;
  font-weight: 600;
  margin: 0;
}

.panel-title-v2 i {
  color: #2c5aa0;
  font-size: 1rem;
}

.accordion_header[aria-expanded="true"] .panel-title-v2 i,
.panel-header-v2[aria-expanded="true"] .panel-title-v2 i {
  color: white;
}

.panel-arrow-v2 {
  transition: transform 0.3s ease;
  color: #6c757d;
  font-size: 0.9rem;
}

.accordion_content {
  background: white;
  border-top: 1px solid #e9ecef;
}

/* Panel Content Styling */
.panel-content-v2 {
  background: white;
  border-top: 1px solid #e9ecef;
}

/* Checkbox Grid */
.checkbox-grid-v2 {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 10px;
  padding: 16px;
}

.checkbox-item-v2 {
  position: relative;
}

.checkbox-v2 {
  position: absolute;
  opacity: 0;
  cursor: pointer;
}

.checkbox-label-v2 {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 10px 14px;
  background: #f8f9fa;
  border: 1px solid #e9ecef;
  border-radius: 6px;
  cursor: pointer;
  transition: all 0.3s ease;
  font-weight: 500;
  color: #495057;
  font-size: 0.9rem;
}

.checkbox-label-v2:hover {
  background: #e9ecef;
  border-color: #2c5aa0;
}

.checkbox-v2:checked+.checkbox-label-v2 {
  background: #2c5aa0;
  border-color: #2c5aa0;
  color: white;
}

.checkbox-label-v2 i {
  font-size: 0.9rem;
  width: 18px;
  text-align: center;
}

/* Order Content Styling */
.order-content__wrapper {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 16px;
  padding: 16px;
}

.order-content__inputs {
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.order-content__inputs .item {
  position: relative;
}

.order-content__inputs .checkbox-input {
  position: absolute;
  opacity: 0;
  cursor: pointer;
}

.order-content__inputs label {
  display: block;
  padding: 10px 14px;
  background: #f8f9fa;
  border: 1px solid #e9ecef;
  border-radius: 6px;
  cursor: pointer;
  transition: all 0.3s ease;
  font-weight: 500;
  color: #495057;
  font-size: 0.9rem;
}

.order-content__inputs label:hover {
  background: #e9ecef;
  border-color: #2c5aa0;
}

.order-content__inputs .checkbox-input:checked+label {
  background: #2c5aa0;
  border-color: #2c5aa0;
  color: white;
}

.order-content__comment {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.order-content__comment>div {
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.order-content__comment .col-form-label {
  font-weight: 600;
  color: #2c3e50;
  margin-bottom: 0;
  font-size: 0.9rem;
}

.order-content__comment .form-control {
  padding: 10px 12px;
  border: 1px solid #e9ecef;
  border-radius: 6px;
  font-size: 0.9rem;
  transition: all 0.3s ease;
  background: white;
}

.order-content__comment .form-control:focus {
  outline: none;
  border-color: #2c5aa0;
  box-shadow: 0 0 0 2px rgba(44, 90, 160, 0.1);
}

.order-content__comment .form-control:disabled {
  background-color: #f8f9fa;
  color: #6c757d;
}

/* Compact styles for Параметри замовлення */
.checkbox-grid-compact {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 8px;
  padding: 12px;
}

.checkbox-label-compact {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 8px 12px;
  background: #f8f9fa;
  border: 1px solid #e9ecef;
  border-radius: 6px;
  cursor: pointer;
  transition: all 0.3s ease;
  font-weight: 500;
  color: #495057;
  font-size: 0.85rem;
  margin-bottom: 0;
}

.checkbox-label-compact:hover {
  background: #e9ecef;
  border-color: #2c5aa0;
}

.checkbox-v2:checked+.checkbox-label-compact {
  background: #2c5aa0;
  border-color: #2c5aa0;
  color: white;
}

.checkbox-label-compact i {
  font-size: 0.9rem;
  width: 16px;
  text-align: center;
}

.order-fields-compact {
  display: grid;
  /* grid-template-columns: 1fr 1fr; */
  gap: 12px;
  padding: 12px;
  border-top: 1px solid #e9ecef;
}

.field-group-compact {
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.field-label-compact {
  font-weight: 600;
  color: #2c3e50;
  font-size: 0.85rem;
  margin: 0;
}

.field-input-compact {
  padding: 8px 10px;
  border: 1px solid #e9ecef;
  border-radius: 6px;
  font-size: 0.85rem;
  transition: all 0.3s ease;
  background: white;
}

.field-input-compact:focus {
  outline: none;
  border-color: #2c5aa0;
  box-shadow: 0 0 0 2px rgba(44, 90, 160, 0.1);
}

.field-input-compact:disabled {
  background-color: #f8f9fa;
  color: #6c757d;
  cursor: not-allowed;
}

textarea.field-input-compact {
  resize: vertical;
  min-height: 60px;
}

/* Input Styling из Form.vue */
.input-group-v2 {
  position: relative;
}

.form-input-v2 {
  width: 100%;
  padding: 12px 14px;
  border: 1px solid #e9ecef;
  border-radius: 7px;
  font-size: 0.95rem;
  transition: all 0.3s ease;
  background: white;
}

.form-input-v2:focus {
  outline: none;
  border-color: #2c5aa0;
  box-shadow: 0 0 0 2px rgba(44, 90, 160, 0.1);
}

.form-input-v2::placeholder {
  color: #6c757d;
}

/* Component Wrapper */
.component-wrapper-v2 {
  background: #f8f9fa;
  border-radius: 8px;
}

/* Component Containers */
.accordion_content .materials-container,
.accordion_content .edges-container,
.accordion_content .screeds-container {
  margin: 0;
  border-radius: 0;
  background: transparent;
  padding: 0;
}

.accordion_content .materials-header,
.accordion_content .edges-header,
.accordion_content .screeds-header {
  padding: 8px 12px;
  border-bottom: 1px solid #dee2e6;
  margin-bottom: 0;
  background: #f8f9fa;
}

.accordion_content .materials-title,
.accordion_content .edges-title,
.accordion_content .screeds-title {
  font-size: 0.8rem;
  font-weight: 600;
  color: #2c3e50;
  display: flex;
  align-items: center;
  gap: 8px;
}

.accordion_content .btn-primary {
  padding: 6px 12px;
  font-size: 0.8rem;
  background: #2c5aa0;
  border-color: #2c5aa0;
}

.accordion_content .btn-primary:hover {
  background: #1e4a8a;
  border-color: #1e4a8a;
}

/* Table Section из Form.vue */
.table-section-v2 {
  margin-top: 18px;
}

.table-card-v2 {
  background: white;
  border-radius: 12px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.08);
  overflow: hidden;
}

.table-header-v2 {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 16px 18px;
  background: #f8f9fa;
  border-bottom: 1px solid #e9ecef;
}

.table-title-v2 {
  font-size: 1.1rem;
  font-weight: 600;
  display: flex;
  align-items: center;
  gap: 10px;
  color: #2c3e50;
  margin: 0;
}

.table-title-v2 i {
  color: #2c5aa0;
  font-size: 1.1rem;
}

.table-content-v2 {
  background: white;
}

.table-wrapper-v2 {
  position: relative;
  overflow: auto;
  max-height: 500px;
  max-width: 100%;
}

/* Button Styles из Form.vue */
.btn-v2 {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  padding: 8px 14px;
  border: none;
  border-radius: 6px;
  font-size: 0.85rem;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.3s ease;
  text-decoration: none;
  white-space: nowrap;
}

.btn-primary-v2 {
  background: #2c5aa0;
  color: white;
}

.btn-primary-v2:hover:not(:disabled) {
  background: #1e4a8a;
  transform: translateY(-1px);
  box-shadow: 0 4px 12px rgba(44, 90, 160, 0.3);
}

.btn-outline-v2 {
  background: transparent;
  color: #2c5aa0;
  border: 2px solid #2c5aa0;
}

.btn-outline-v2:hover:not(:disabled) {
  background: #2c5aa0;
  color: white;
  transform: translateY(-1px);
  box-shadow: 0 4px 12px rgba(44, 90, 160, 0.3);
}

.btn-sm-v2 {
  padding: 6px 10px;
  font-size: 0.75rem;
}

.btn-v2:disabled {
  opacity: 0.6;
  cursor: not-allowed;
  transform: none;
  box-shadow: none;
}

/* Visual Section из Form.vue */
.visual-card-v2 {
  height: 100%;
}

.visual-header-v2 {
  padding: 15px 18px;
  background: #f8f9fa;
  border-bottom: 1px solid #e9ecef;
}

.visual-header-v2 h3 {
  margin: 0;
  font-size: 1.1rem;
  font-weight: 600;
  display: flex;
  align-items: center;
  gap: 10px;
  color: #2c3e50;
}

.visual-header-v2 i {
  color: #2c5aa0;
}

.visual-content-v2 {
  padding: 18px;
  background: white;
}
</style>